import { z } from 'zod';
import { UserRole } from '@lombok/shared';

/**
 * Login form schema (React Hook Form + Zod). Email + password are the real
 * credentials submitted to Cognito. `role` is OPTIONAL and used ONLY by the
 * dev-fallback provider (no Cognito configured) so every portal is reachable
 * for local review — it is ignored on the real auth path, where the role comes
 * from the verified JWT.
 */
export const loginSchema = z.object({
  email: z.string().min(1, 'Ingresa tu correo').email('Correo no válido'),
  password: z.string().min(1, 'Ingresa tu contraseña'),
  role: z.nativeEnum(UserRole).optional(),
});

export type LoginValues = z.infer<typeof loginSchema>;
